import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { ScreensDemoCoreModule } from './core';
import { ScreensDemoAppRoutingModule } from './mras-app-routing.module';
import { ScreensInterviewModule } from './interview/screens-interview.module';
import moment from 'moment';
import { JhiMainComponent, ErrorComponent } from './layouts';
import { SharedModule } from '@Shared/shared.module';

@NgModule({
    imports: [
        ScreensDemoCoreModule,
        ScreensInterviewModule,
        ScreensDemoAppRoutingModule,
        SharedModule,
        ErrorComponent
    ],
    declarations: [JhiMainComponent],
    providers: [],
    bootstrap: [JhiMainComponent],
    exports: [ScreensInterviewModule]
})
export class MrasAppModule {
    constructor(private dpConfig: NgbDatepickerConfig) {
        this.dpConfig.minDate = { year: moment().year() - 100, month: 1, day: 1 };
    }
}
